import { useEffect, useState } from "react";
import { Box, CircularProgress, DialogTitle } from "@mui/material";
import { toast } from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BASE_URL } from "../../../components/BaseUrl";
import {
  setInviteProfileUpdateToken,
  setInviteEmail as setInviteEmailRedux,
} from "../../../Redux/Slices/AuthSlice";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import warning from "../../../assets/warning.svg";
import { useTheme } from "@mui/material/styles";
import CustomEmailInput from "../../../components/EmailInput"; // ✅ import
import { useTranslation } from 'react-i18next';

const VerifyInvite = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const token = searchParams.get("token");
  const theme = useTheme();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [email, setEmail] = useState(""); // 👈 for input

const [waiting, setWaiting] = useState(true); // ⏳ first 60s no loader
const [loading, setLoading] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

useEffect(() => {
  const verifyInvite = async () => {
    if (!userId || !token) {
      setErrorMessage("Invalid or missing verification link.");
      setWaiting(false);
      return;
    }

    try {
      // ⏳ Step 1: wait for 1 minute
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setWaiting(false);   // stop idle
      setLoading(true);    // show loader

      // ⏳ Step 2: call API
      const url = `${BASE_URL}/public/company-admin/verify-invite?userId=${userId}&token=${token}`;
      const response = await fetch(url, { method: "GET" });
      const data = await response.json();

      console.log("🔍 VerifyInvite response:", data);

      if (!response.ok || data.error) {
        setErrorMessage(data.message || "Invite verification failed");
        return;
      }

      toast.success(data.message || "Invite verified successfully");

      const profileToken = data.data?.profileUpdateToken;
      sessionStorage.removeItem("invitePasswordCompleted");

      if (profileToken) {
        dispatch(setInviteProfileUpdateToken(profileToken));
        localStorage.setItem("inviteProfileUpdateToken", profileToken);
      }

      if (data.data?.email) {
        dispatch(setInviteEmailRedux(data.data.email));
        localStorage.setItem("inviteEmail", data.data.email);
      }

      setTimeout(() => {
        navigate("/set-password", { replace: true });
      }, 1000);
    } catch (err) {
      console.error("🚨 VerifyInvite catch:", err);
      setErrorMessage(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  verifyInvite();
}, [userId, token, dispatch, navigate]);



  // 🔁 Resend Invite API
  const handleResendInvite = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/public/company-admin/resend-verification`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // 👈 token in header
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();
      console.log("🔁 ResendInvite response:", data);

      if (!response.ok || data.error) {
        throw new Error(data.message || "Failed to resend invite");
      }

      toast.success(data.message || "Invite resent successfully!");
      //    setTimeout(() => {
      //   navigate("/set-password");
      // }, 1000);
    } catch (err) {
      toast.error(err.message || "Error while resending invite");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EFF4F8",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      {loading ? (
        <CircularProgress size={40} />
      ) : errorMessage ? (
        <Box
          sx={{
            maxWidth: 420,
            width: "100%",
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: 0,
            p: 3,
            textAlign: "center",
          }}
        >
          <DialogTitle sx={{ textAlign: "center" }}>
            <img src={warning} style={{ width: 70, height: 70 }} alt="warning" />
          </DialogTitle>

          <CustomText
            sx={{
              ...textStyles.body4,
              color: theme.palette.text.primary,
              mb: 2,
            }}
          >
            {errorMessage}
          </CustomText>

          {/* ✅ Styled email input */}
          <label
            style={{
              display: "block",
              textAlign: "left",
              marginBottom: 6,
              fontSize: 14,
              fontWeight: 500,
              color: theme.palette.text.primary,
            }}
          >
            {t("invite.emailLabel")}
          </label>
          <CustomEmailInput
            name="email"
            placeholder="john@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <CustomButton
            onClick={handleResendInvite}
            disabled={loading}
            sx={{ mt: 2 }}
            label={
              loading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                 {t("invite.resending")}
                </Box>
              ) : (
                t("invite.resendButton")
              )
            }
          />
        </Box>
      ) : null}
      
    </Box>
    
  );
};

export default VerifyInvite;







